import { TiExportOutline } from "react-icons/ti";
import { RiBarcodeLine } from "react-icons/ri";
import { Box } from "@chakra-ui/react";
import { showError, showSuccess } from "infra/helpers/alerta";
import { ContaItemResponse } from "features/conta/typings";
import { MdCancel, MdCheck, MdDelete, MdRefresh, MdMail } from "react-icons/md";
import { FaHandshake } from "react-icons/fa";
import { OperacaoEnum } from "resources/enums/conta";
import { PermissaoEnum } from "resources/enums/permissao";
import * as _ from "lodash";
import { OrigemContaEnum } from "core/features/cobranca/typings";
import { ActionBottomType } from "./../../../BottomTableFixed/index";

export const actions = (
  selectedRows: ContaItemResponse[],
  operacao: OperacaoEnum,
  fns: {
    onAcordo: (ids: string[]) => void;
    onLiquidar: (ids: string[]) => void;
    onDelete: (ids: string[]) => void;
    onCancelarCobranca: (ids: string[]) => void;
    onExportar: (ids: string[]) => void;
    onEmail: (ids: string[]) => void;
    onReprocessarConta: (ids: string[], fn: any) => void;
    onVerBoletos: (rows: ContaItemResponse[]) => void;
    onBaixarPdfsIndividuais: (rows: ContaItemResponse[]) => void;
    isCreatingGrupo: boolean;
    refresh: () => void;
  },
) => {
  const hasSelectedAcordoConta = selectedRows.some(
    (row) => row.origemContaId === OrigemContaEnum.Acordo,
  );

  const hasSelectedContaPaga = selectedRows.some((row) => !!row.dataPagamento);

  const result: ActionBottomType[] = [
    {
      title: selectedRows.length > 1 ? "Ver boletos" : "Ver boleto",
      icon: <RiBarcodeLine />,
      disableMultiple: false,
      isLoading: fns.isCreatingGrupo,
      onClick: () =>
        selectedRows.length > 1
          ? fns.onBaixarPdfsIndividuais(selectedRows)
          : fns.onVerBoletos(selectedRows),
    },
    {
      title: "Liquidar",
      disableMultiple: false,
      disabled: hasSelectedContaPaga,
      onClick: () => fns.onLiquidar(selectedRows.map((item) => item.id)),
      icon: (
        <Box w="15px">
          <MdCheck size={20} />
        </Box>
      ),
      permissions:
        operacao === OperacaoEnum.Despesa
          ? [PermissaoEnum.Backoffice.Financeiro.ContasPagar.Liquidar]
          : [PermissaoEnum.Backoffice.Financeiro.ContasReceber.Liquidar],
    },
  ];

  if (operacao === OperacaoEnum.Receita) {
    result.push({
      title: "Fazer Acordo",
      icon: <FaHandshake />,
      disabled: hasSelectedAcordoConta,
      htmlTitleTag: hasSelectedAcordoConta
        ? "Não é possível fazer acordo pois alguma conta selecionada já foi originada de outro acordo. Utilize a tela de detalhe do acordo."
        : undefined,
      onClick: () => {
        const groupsUnidades = Object.keys(_.groupBy(selectedRows, "unidade"));

        if (groupsUnidades.length > 1) {
          return showError(
            "Não é possível realizar o acordo. As contas precisam ser da mesma unidade.",
          );
        }

        fns.onAcordo(selectedRows.map((item) => item.id));
      },
    });

    result.push({
      title: "Exportar Remessa",
      icon: <TiExportOutline />,
      onClick: () => fns.onExportar(selectedRows.map((item) => item.id)),
    });

    result.push({
      title: "Recriar Boleto",
      icon: <MdRefresh />,
      onClick: () => {
        fns.onReprocessarConta(
          selectedRows.map((item) => item.id),
          {
            onSuccess: async () => {
              if (selectedRows.length === 1) {
                await showSuccess("Boleto recriado com sucesso!");
              } else {
                await showSuccess("Boletos recriados com sucesso!");
              }
              fns.refresh();
            },
          },
        );
      },
    });
  }

  if (operacao === OperacaoEnum.Receita) {
    result.push({
      title: "Cancelar Cobrança",
      icon: <MdCancel />,
      disabled: hasSelectedContaPaga,
      htmlTitleTag: hasSelectedContaPaga
        ? "Não é possível cancelar a cobrança de uma conta que já foi paga."
        : undefined,
      permissions: [PermissaoEnum.Backoffice.Financeiro.ContasReceber.Excluir],
      onClick: () =>
        fns.onCancelarCobranca(selectedRows.map((item) => item.id)),
    });
  }

  if (operacao === OperacaoEnum.Receita) {
    result.push({
      title: "Reenviar Emails",
      icon: <MdMail />,
      onClick: () => fns.onEmail(selectedRows.map((item) => item.id)),
    });
  }

  result.push({
    title: "Excluir",
    icon: <MdDelete />,
    permissions:
      operacao === OperacaoEnum.Despesa
        ? [PermissaoEnum.Backoffice.Financeiro.ContasPagar.Excluir]
        : [PermissaoEnum.Backoffice.Financeiro.ContasReceber.Excluir],
    onClick: () => {
      fns.onDelete(selectedRows.map((item) => item.id));
    },
  });

  return result;
};
